import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=7440d8b6&scoped=true&"
import script from "./VFooter.vue?vue&type=script&lang=js&"
export * from "./VFooter.vue?vue&type=script&lang=js&"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=7440d8b6&scoped=true&lang=scss&"
import style1 from "./VFooter.vue?vue&type=style&index=1&id=7440d8b6&scoped=true&lang=scss&"
import style2 from "./VFooter.vue?vue&type=style&index=2&id=7440d8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7440d8b6",
  null
  
)

export default component.exports